import { WebsiteRead } from '@/api/dashboard'
import { fetchWebsiteDefaultTheme } from './fetchWebsiteDefaultTheme'
import { Theme } from '../types'

/**
 * Fetches the website them..
 * @param website
 * @returns
 */
export const fetchWebsiteTheme = async (website: WebsiteRead): Promise<Theme> => {
  if (!website.config?.theme_raw_url) {
    return await fetchWebsiteDefaultTheme(website, 'dark')
  }
  try {
    const res = await fetch(website.config?.theme_raw_url)
    return await res.json()
  } catch (e) {
    return await fetchWebsiteDefaultTheme(website, 'dark')
  }
}
